<template>
  <v-dialog v-model="dialog" scrollable max-width="500">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" class="primary" depressed>View</v-btn>
    </template>
    <v-card>
      <v-card-title>
        Job Numbers
      </v-card-title>
      <v-card-text>
        <div class="subtitle-1">
          Field: <b>{{ item.field }}</b>
        </div>
        <div class="subtitle-1" v-html="range"></div>
        <div v-for="j in item.jobs" :key="j">
          <div class="subtitle-1 font-weight-bold pt-1">
            {{ j }}
          </div>
          <v-divider></v-divider>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" @click="dialog = false" text>Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    range: {},
    field: {},
    item: {}
  },
  data() {
    return {
      dialog: false
    };
  }
};
</script>

<style></style>
